import React, { PureComponent } from 'react';
import Product from '../Product/ProductContainer';
import { isEqual } from 'lodash';
import { setUrlParams } from './AppState';
import Config from '../../Config.js';
import classNames from 'classnames';

class App extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isLandscapeMode: window.innerWidth > window.innerHeight
    };

    // Some devices haven't provided the orientationchange event, but do fire the window's resize event
    window.addEventListener('resize', () => {
      this.setState({ isLandscapeMode: window.innerWidth > window.innerHeight });
    }, false);
  }

  componentWillMount() {
    this.props.dispatch(setUrlParams({
      urlParams: this.props.urlParams
    }));
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.urlParams, this.props.urlParams)) {
      this.props.dispatch(setUrlParams({
        urlParams: nextProps.urlParams
      }));
    }
  }

  render() {
    const landscapeMode = classNames(
      {
        landscape: this.state.isLandscapeMode,
      });
    return (
      <div className={`is-landscape ${landscapeMode}`} >
        {this.props.products.length ?
          <Product
            products={this.props.products}
            optionals={this.props.optionals}
            basemaps={this.props.basemaps}
            defaultBasemapId={this.props.defaultBasemapId}
            productId={this.props.match.params.productId || Config.DEFAULT_PRODUCT_ID}
            menuGroups={this.props.menuGroups}
            tabId={this.props.tabId}
            location={this.props.location}
            warnings={this.props.warnings}
            isMenuOpen={this.props.isMenuOpen}
            isFakeFullscreenOpen={this.props.isFakeFullscreenOpen}
            isFullScreen={this.props.isFullScreen}
            productConfig={this.props.productConfig}
            urlParams={this.props.urlParams}
            productFamilies={this.props.productFamilies}
            legendVisible={this.props.legendVisible}
          /> : null
        }
      </div>
    );
  }
}


export default App;



/** WEBPACK FOOTER **
 ** ./apps/maptool/modules/App/App.js
 **/